import { Pipe } from '@angular/core';
var UnionPipe = (function () {
    function UnionPipe() {
    }
    UnionPipe.prototype.transform = function (input, args) {
        if (args === void 0) { args = []; }
        if (!Array.isArray(input) || !Array.isArray(args)) {
            return input;
        }
        return args.reduce(function (newArr, currArr) {
            return newArr.concat(currArr.reduce(function (noDupArr, curr) {
                // tslint:disable-next-line:no-bitwise
                return (!~noDupArr.indexOf(curr) && !~newArr.indexOf(curr))
                    ? noDupArr.concat([curr])
                    : noDupArr;
            }, []));
        }, input);
    };
    UnionPipe.decorators = [
        { type: Pipe, args: [{ name: 'union' },] },
    ];
    /** @nocollapse */
    UnionPipe.ctorParameters = function () { return []; };
    return UnionPipe;
}());
export { UnionPipe };
//# sourceMappingURL=union.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/array/union.js
// module id = 236
// module chunks = 4